/*
 * Copyright (c) 2024. Tooling Team
 */

import OverlayTrigger from "react-bootstrap/OverlayTrigger";
import Popover from "react-bootstrap/Popover";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { regular } from "@fortawesome/fontawesome-svg-core/import.macro";

//cell renderer for Local and Standard description. Since it's used by both, generic variables and string manipulation to get tooltip header.
export default function DescriptionCellRenderer(params) {
  const cellId = params.column.colId;
  const regex = /([A-Z])([a-z]*)/;
  let displayName = cellId.replace(regex, " $1$2");
  displayName = displayName.charAt(0).toUpperCase() + displayName.slice(1);
  if (params.data[cellId]) {
    //16 is default width of current description cols
    if (params.data[cellId].length > 16 && !params?.showFullContent) {
      const popover = (
        <Popover id="popover-basic">
          <Popover.Header as="h3">{displayName}</Popover.Header>
          <Popover.Body>{params.data[cellId]}</Popover.Body>
        </Popover>
      );

      return (
        <div className="localDescIcon mt-2andaBit fa-lg localDescIconCustom">
          <OverlayTrigger
            trigger={["hover", "focus"]}
            placement="right"
            overlay={popover}
          >
            <div>
              <FontAwesomeIcon icon={regular("rectangle-list")} />
            </div>
          </OverlayTrigger>
        </div>
      );
    } else {
      return params.data[cellId];
    }
  } else {
    return null;
  }
}
